/**
 * Video Stories Component
 * Handles video modal playback for the video stories section
 */

if (typeof window.videoStoriesInitialized === 'undefined') {
  window.videoStoriesInitialized = true;

  class VideoStories {
    constructor() {
      this.currentModal = null;
      this.init();
    }

    init() {
      // Wait for tingle to be loaded
      if (typeof tingle === 'undefined') {
        console.warn('Tingle modal library not loaded. Retrying...');
        setTimeout(() => this.init(), 100);
        return;
      }

      // Bind click events
      this.bindEvents();

      console.log('Video Stories initialized');
    }

    bindEvents() {
      // Use event delegation for better performance
      document.addEventListener('click', (e) => {
        const videoCard = e.target.closest('.video-story-card__inner');
        if (videoCard) {
          e.preventDefault();
          this.handleVideoClick(videoCard);
        }
      });

      // Re-bind events after section is reloaded (for theme editor)
      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', () => {
          console.log('Video Stories section reloaded');
        });
      }
    }

    handleVideoClick(videoCard) {
      const videoId = videoCard.dataset.videoId;
      const videoType = videoCard.dataset.videoType;

      if (!videoId) {
        console.warn('No video ID found');
        return;
      }

      this.playVideo(videoId, videoType);
    }

    playVideo(videoId, videoType = 'youtube') {
      let videoUrl = '';

      if (videoType === 'youtube') {
        // YouTube embed URL with autoplay
        videoUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`;
      } else if (videoType === 'vimeo') {
        // Vimeo embed URL with autoplay
        videoUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
      } else {
        console.error('Unsupported video type:', videoType);
        return;
      }

      // Destroy previous modal if exists
      if (this.currentModal) {
        try {
          this.currentModal.destroy();
        } catch (e) {
          console.warn('Error destroying modal:', e);
        }
        this.currentModal = null;
      }

      // Create new modal instance for each video
      this.currentModal = new tingle.modal({
        footer: false,
        stickyFooter: false,
        closeMethods: ['overlay', 'button', 'escape'],
        closeLabel: "关闭",
        cssClass: ['video-stories-modal'],
        onOpen: () => {
          document.body.style.overflow = 'hidden';
        },
        onClose: () => {
          document.body.style.overflow = '';
          // Destroy modal after close
          setTimeout(() => {
            if (this.currentModal) {
              try {
                this.currentModal.destroy();
              } catch (e) {
                console.warn('Error destroying modal on close:', e);
              }
              this.currentModal = null;
            }
          }, 100);
        }
      });

      // Create iframe wrapper HTML
      const iframeHTML = this.createVideoIframeHTML(videoUrl);

      // Set modal content
      this.currentModal.setContent(iframeHTML);

      // Open modal
      this.currentModal.open();
    }

    createVideoIframeHTML(url) {
      return `
        <div class="video-modal-wrapper">
          <iframe 
            src="${url}" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowfullscreen
            frameborder="0"
          ></iframe>
        </div>
      `;
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new VideoStories();
    });
  } else {
    new VideoStories();
  }
}

